export default "__VITE_ASSET__BHXv0IU$__"